export const COMPANY = {
  brandName: 'WaitHere',
  legalName: 'Sahel Software LTDA',
  cnpj: '46.879.146/0001-50',
  website: 'https://waithere.com.br',
}
